import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/gold-logo-transparent.png'


const _hoisted_1 = { class: "min-h-screen bg-black-primary text-white font-inter p-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "flex flex-wrap gap-3 mb-6" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" }
const _hoisted_5 = { class: "bg-gradient-to-br from-[#BC8809] to-gold-customYellow rounded-2xl p-6 shadow-lg flex flex-col items-center justify-center animate-pop-in min-h-[120px]" }
const _hoisted_6 = { class: "text-4xl font-bold flex items-center justify-center" }
const _hoisted_7 = { class: "bg-gradient-to-br from-[#BC8809] to-gold-customYellow rounded-2xl p-6 shadow-lg flex flex-col items-center animate-pop-in delay-100 min-h-[120px]" }
const _hoisted_8 = { class: "text-4xl font-bold flex items-center justify-center" }
const _hoisted_9 = { class: "bg-gradient-to-br from-[#BC8809] to-gold-customYellow rounded-2xl p-6 shadow-lg flex flex-col items-center animate-pop-in delay-200 min-h-[120px]" }
const _hoisted_10 = { class: "text-4xl font-bold flex items-center justify-center" }
const _hoisted_11 = { class: "mb-10" }
const _hoisted_12 = { class: "bg-black-secondary rounded-2xl p-4" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center justify-center py-8"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "text-center text-gray-400 py-8"
}
const _hoisted_16 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
}
const _hoisted_17 = { class: "flex items-start justify-between mb-2" }
const _hoisted_18 = { class: "text-lg font-semibold" }
const _hoisted_19 = { class: "text-sm text-gray-400" }
const _hoisted_20 = { class: "text-sm text-gray-300" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "mt-2 text-sm text-gray-400 line-clamp-3"
}
const _hoisted_24 = { class: "mt-3 text-xs text-gray-500" }
const _hoisted_25 = { class: "mt-3 flex items-center gap-2" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-16"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "flex justify-between items-center mb-4" }
const _hoisted_32 = { class: "overflow-x-auto rounded-2xl shadow-lg bg-black-secondary" }
const _hoisted_33 = { class: "w-full text-sm text-white table-auto animate-fade-in" }
const _hoisted_34 = { class: "border px-4 py-2" }
const _hoisted_35 = { class: "border px-4 py-2" }
const _hoisted_36 = { class: "border px-4 py-2" }
const _hoisted_37 = { class: "border px-4 py-2" }
const _hoisted_38 = { class: "border px-4 py-2" }
const _hoisted_39 = { class: "border px-4 py-2" }
const _hoisted_40 = { class: "border px-4 py-2" }
const _hoisted_41 = { class: "border px-4 py-2" }
const _hoisted_42 = {
  key: 0,
  class: "text-center text-gray-400 py-8"
}
const _hoisted_43 = {
  key: 0,
  class: "flex justify-center items-center gap-2 mt-6"
}
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "mx-2 text-gold" }
const _hoisted_46 = ["disabled"]

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { generateCsv, formatFirebaseTimestamp } from '@/helpers';
import UserService from '@/service/user.service';
import RequestService from '@/service/request.service';
import LoadingSpinner from '@/components/admin-dashboard/LoadingSpinner.vue';
import InquiryService, { type PartnerInquiry } from '@/service/inquiry.service';

const pageSize = 100;

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminPanelView',
  setup(__props) {

const router = useRouter();

const users = ref<any[]>([]);
const usersCount = ref(0);
const requestsCount = ref(0);
const loading = ref(true);
const currentPage = ref(1);
const lastDocs = ref<any[]>([null]); // Store lastDoc for each page (0 = null for first page)
const totalPages = ref(1);
const paidRequestsCount = ref(0);
const inquiries = ref<PartnerInquiry[]>([]);
const loadingInquiries = ref(false);

async function fetchStats() {
  loading.value = true;
  usersCount.value = await UserService.getUsersCount();
  requestsCount.value = await RequestService.getRequestsCount();
  paidRequestsCount.value = await RequestService.getPaidRequestsCount();
  totalPages.value = Math.max(1, Math.ceil(usersCount.value / pageSize));
  loading.value = false;
}

async function fetchUsers(page: number) {
  loading.value = true;
  let lastDoc = null;
  if (page > 1) {
    lastDoc = lastDocs.value[page - 1];
  }
  const { users: pageUsers, lastDoc: newLastDoc } = await UserService.getUsersPaginated(pageSize, lastDoc);
  users.value = pageUsers;
  // Store lastDoc for this page for navigation
  lastDocs.value[page] = newLastDoc;
  loading.value = false;
}

onMounted(async () => {
  // if (!localStorage.getItem('loggedIn')) {
  //   router.push({ name: 'admin-login' });
  //   return;
  // }
  await fetchStats();
  await fetchUsers(1);
  loadingInquiries.value = true;
  inquiries.value = await InquiryService.getPartnerInquiries();
  loadingInquiries.value = false;
});

async function goToPage(page: number) {
  if (page < 1 || page > totalPages.value) return;
  currentPage.value = page;
  await fetchUsers(page);
}

async function downloadCsv(collection: string) {
  await generateCsv();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-3xl md:text-4xl font-bold text-gold mb-2 animate-fade-in" }, " Admin Dashboard "),
          _createElementVNode("p", { class: "text-lg text-gray-300 animate-fade-in-slow" }, " Manage users, requests, and platform data. ")
        ]),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "TALAB Logo",
          class: "w-24 md:w-32 animate-fade-in"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'partners-overview' }))),
          class: "px-4 py-2 rounded-lg bg-gold-primary text-black font-semibold hover:bg-gold-secondary transition border border-gold-secondary"
        }, " Open Partners Overview "),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'admin-dashboard-kpis' }))),
          class: "px-4 py-2 rounded-lg bg-black-secondary text-gold border border-gold-secondary font-semibold hover:bg-gold-primary hover:text-black transition"
        }, " Open KPIs & Goals "),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'admin-dashboard-workspace' }))),
          class: "px-4 py-2 rounded-lg bg-black-secondary text-gold border border-gold-secondary font-semibold hover:bg-gold-primary hover:text-black transition"
        }, " Open Workspace ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(usersCount.value), 1),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-lg font-medium mt-2" }, "User Accounts", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(requestsCount.value), 1),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-lg font-medium mt-2" }, "Requests", -1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createTextVNode(_toDisplayString(((paidRequestsCount.value / (usersCount.value || 1)) * 100).toFixed(2)) + " ", 1),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ml-1 text-2xl" }, "%", -1))
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-lg font-medium mt-2" }, "Request/User Ratio", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
          _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Partner Inquiries")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          (loadingInquiries.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(LoadingSpinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (inquiries.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "No inquiries yet."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inquiries.value, (inq) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: inq.id,
                          class: "bg-black-primary/70 border border-zinc-800 rounded-xl p-4"
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(inq.name), 1),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(inq.email), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-xs px-2 py-1 rounded-full border", {
                      'text-yellow-300 border-yellow-300': inq.status==='new',
                      'text-blue-300 border-blue-300': inq.status==='contacted',
                      'text-green-300 border-green-300': inq.status==='qualified',
                      'text-gray-300 border-gray-300': inq.status==='closed',
                  }])
                            }, _toDisplayString(inq.status), 3)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            (inq.company)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Company: " + _toDisplayString(inq.company), 1))
                              : _createCommentVNode("", true),
                            (inq.phone)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Phone: " + _toDisplayString(inq.phone), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (inq.message)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(inq.message), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_24, " Submitted: " + _toDisplayString(inq.createdAt ? _unref(formatFirebaseTimestamp)(inq.createdAt as any, true) : '—'), 1),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              class: "text-xs px-3 py-1 rounded bg-gold-primary text-black hover:bg-gold-secondary",
                              onClick: ($event: any) => (_unref(InquiryService).updateInquiryStatus(inq.id!, 'contacted').then(()=>inq.status='contacted'))
                            }, "Mark Contacted", 8, _hoisted_26),
                            _createElementVNode("button", {
                              class: "text-xs px-3 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-500",
                              onClick: ($event: any) => (_unref(InquiryService).updateInquiryStatus(inq.id!, 'qualified').then(()=>inq.status='qualified'))
                            }, "Qualify", 8, _hoisted_27),
                            _createElementVNode("button", {
                              class: "text-xs px-3 py-1 rounded bg-zinc-700 text-white hover:bg-zinc-600",
                              onClick: ($event: any) => (_unref(InquiryService).updateInquiryStatus(inq.id!, 'closed').then(()=>inq.status='closed'))
                            }, "Close", 8, _hoisted_28)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]))
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(LoadingSpinner),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "w-full max-w-2xl mt-8" }, [
              _createElementVNode("div", { class: "h-8 bg-zinc-800 rounded mb-4 animate-pulse" }),
              _createElementVNode("div", { class: "h-8 bg-zinc-800 rounded mb-4 animate-pulse" }),
              _createElementVNode("div", { class: "h-8 bg-zinc-800 rounded mb-4 animate-pulse" })
            ], -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "User Accounts", -1)),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (downloadCsv('users'))),
                class: "text-lg text-gold-primary border border-gold-primary px-4 py-2 rounded-lg hover:bg-gold-primary hover:text-black transition"
              }, " Download users (csv) ")
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("table", _hoisted_33, [
                _cache[13] || (_cache[13] = _createElementVNode("thead", { class: "text-xs uppercase bg-black-primary/90 text-gold sticky top-0 z-10" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-4 py-3" }, "ID"),
                    _createElementVNode("th", { class: "px-4 py-3" }, "Fullname"),
                    _createElementVNode("th", { class: "px-4 py-3" }, "Email"),
                    _createElementVNode("th", { class: "px-4 py-3" }, "University"),
                    _createElementVNode("th", { class: "px-4 py-3" }, "Phone"),
                    _createElementVNode("th", { class: "px-4 py-3" }, "Registration Date"),
                    _createElementVNode("th", { class: "px-4 py-3" }, "Referred By"),
                    _createElementVNode("th", { class: "px-4 py-3" }, "Platform")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.id,
                      class: "odd:bg-black-primary/80 even:bg-black-primary/60 border-b border-zinc-800 transition-all duration-300 hover:bg-gold-secondary/10 animate-pop-in"
                    }, [
                      _createElementVNode("td", _hoisted_34, _toDisplayString(user.id), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(user.fullName), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(user.email), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(user.university), 1),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(user.phoneNumber), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(formatFirebaseTimestamp)(user.registrationDate, true)), 1),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(user.referredBy
                      ? users.value.find((x) => x.userId === user.referredBy)
                          ?.fullName || "none"
                      : "none"), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(user.platform), 1)
                    ]))
                  }), 128))
                ])
              ]),
              (users.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, " No users found. "))
                : _createCommentVNode("", true)
            ]),
            (totalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("button", {
                    class: "px-3 py-1 rounded bg-black-secondary border border-gold-primary text-gold hover:bg-gold-primary hover:text-black transition",
                    disabled: currentPage.value === 1,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPage(currentPage.value - 1)))
                  }, " Prev ", 8, _hoisted_44),
                  _createElementVNode("span", _hoisted_45, "Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(totalPages.value), 1),
                  _createElementVNode("button", {
                    class: "px-3 py-1 rounded bg-black-secondary border border-gold-primary text-gold hover:bg-gold-primary hover:text-black transition",
                    disabled: currentPage.value === totalPages.value,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage(currentPage.value + 1)))
                  }, " Next ", 8, _hoisted_46)
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}
}

})